import { render, staticRenderFns } from "./voicemail-icon.vue?vue&type=template&id=48f5b988"
import script from "./voicemail-icon.vue?vue&type=script&lang=js"
export * from "./voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports